<template>
  <v-dialog max-width="440" :value="visible" content-class="rounded-10" style="z-index: 15" @input="$emit('input', $event)">
    <v-sheet class="rounded-10 px-2 px-md-4 py-4 py-md-10 d-flex flex-column align-center" color="#f7f2f7">
      <img src="@/assets/warning.png" class="icon" />

      <v-container fluid>
        <p class="text-center px-1 text-body-1" style="word-break: keep-all; word-wrap: break-word">
          리뷰 쓰기는 '공주의 앨범'에서 완료 이미지를 선택하신 후 리뷰 쓰기 메뉴를 이용해 작성하실 수 있습니다.<br /><br />
          '공주의 앨범'으로 이동 하시겠습니까?
        </p>
      </v-container>

      <v-container fluid class="d-flex justify-center mt-2">
        <v-btn color="white" class="dialog_btn rounded-2 mr-2 grey--text" width="35%" style="font-size: 20px" depressed @click="$emit('close')" large> 아니오 </v-btn>
        <v-btn color="#d9bddd" class="dialog_btn rounded-2 ml-2" style="font-size: 18px" width="35%" depressed @click="confirmClick" large>예</v-btn>
      </v-container>
    </v-sheet>
  </v-dialog>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    confirmClick() {
      this.$emit("confirm")
    },
  },
}
</script>
<style scoped>
.icon {
  width: 60px;
  height: 60px;
}
.dialog_btn {
  border: 2px solid #dadada !important;
  font-size: 16px;
}
::v-deep .v-btn:not(.v-btn--disabled) {
  color: rgb(71, 71, 71);
}
</style>
